export default "__VITE_ASSET__6b304f0e__"